import type { InsightSeries } from "@lib/types/insights";
import { getMetricType } from "./insights-metrics";

/**
 * Check if a metric is a percentage type (CTR, Conversion Rate, New Customer Rate)
 * These metrics are returned from the API as decimals (0.01 for 1%) and need
 * to be multiplied by 100 for display.
 */
export function isPercentageMetric(metric: string): boolean {
  return getMetricType(metric) === "percentage";
}

/**
 * Check if ALL series in an insight use percentage metrics.
 * Used to determine if cumulative chart type should be disabled,
 * since summing rates is mathematically meaningless.
 */
export function allSeriesArePercentageMetrics(
  series: InsightSeries[]
): boolean {
  if (series.length === 0) return false;
  return series.every((s) => isPercentageMetric(s.metric));
}
